var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.439 6.30019C17.3588 5.07761 15.9193 4.1484 14.2254 3.69453C9.63844 2.46546 4.92361 5.18757 3.69453 9.77454C3.28918 11.2873 3.3136 12.814 3.69293 14.225M18.439 6.30019L13.1127 7.84725M18.439 6.30019L17.1363 1.13635M5.5646 17.7039C6.64439 18.9245 8.0826 19.8521 9.77454 20.3054C14.3615 21.5345 19.0763 18.8124 20.3054 14.2254C20.7108 12.7126 20.6864 11.1859 20.307 9.77497M5.5646 17.7039L10.8873 16.1527M5.5646 17.7039L6.86364 22.8636",
    stroke: "#EDAA8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapTransaction);
export default __webpack_public_path__ + "static/media/swapTransaction.61a9e5fa0973a6b9910231d343293cc0.svg";
export { ForwardRef as ReactComponent };